module.exports = __webpack_public_path__ + "img/footer05.52883eaa.png";